import React, { useEffect, useState , useContext } from 'react';
import { useParams } from 'react-router';
import { Redirect , useHistory } from 'react-router-dom';
import GoogleIcon from '@mui/icons-material/Google';
import '../Home/homePage.scss';
import {auth,provider} from "../Collaboration/config";
import {signInWithPopup} from "firebase/auth";
import { VERSION } from '../../common/version';
import {fetchCurrentAgent} from '../../apiCall';
import Context from '../../context/context';


function ByAgent() {
    const { id } = useParams();
    useEffect(()=>{
        console.log(id)
    }, [])

    const [value,setValue] = useState('')
  const history = useHistory();
  const version = VERSION;
  const {state, dispatch} = useContext(Context);
  const setAgentDispatch = data => dispatch({type:"SET_AGENT", payload: data});

  const handleClick = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        console.log(result.user)
        fetchCurrentAgent(id, function (response) {
          console.log(response.result.agentData)
          if(response.result){
            setAgentDispatch(response.result.agentData)
            const { displayName, email, phoneNumber, photoURL, uid } = result.user;
            const linkType = "ByAgent" ; 
            history.push({
              pathname: "/invite",
              state: {
                displayName,
                email,
                phoneNumber,
                photoURL,
                uid,
                linkType , 
                agent : response.result.agentData
              },
            });
          }
        }).then(() => {

        }).catch(() => {
        });

      })
      .catch((error) => {
      });
  };
  
  useEffect(()=>{
    setValue(localStorage.getItem('email'))
  } , [])
  
  if (value) {
    return <Redirect to="/Invite" />;
  }

  return (
    <div className='homePage'>
    <div className='logo' style={{ 'textAlign': 'center' }}>
    <p style={{'textAlign': 'right' , 'padding' : '5px'}}> בס"ד </p>
      <img className="homeImage" src="/home-logo-v3.png" alt="logo-pych" />
    </div>
{/* TODO remove */}
<button className='googleBtn' onClick={handleClick}>
    <GoogleIcon />
    התחבר עם גוגל
  </button>
  </div>

 )
{/* <div
  className="homePage"
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    flexDirection: "column",
    textAlign: "center"
  }}
>
  <div>
    <h3>לקוחות יקרים ההרשמה תיפתח בקרוב</h3>
    <h4>צוות פאייכלה</h4>
    <img className="homeImage" src="/home-logo-v3.png" alt="logo-pych" />
  </div>
</div> */}


 
}

export default ByAgent